import { useEffect } from 'react';
import { usePreviewStore } from '../../../stores/previewStore';
import PreviewToolbar from './PreviewToolbar';
import PreviewCanvas from './PreviewCanvas';
import ADACompliancePanel from './ADACompliancePanel';
import PreviewInfoPanel from './PreviewInfoPanel';

export default function PreviewShell() {
  const {
    setPreviewMode,
    exitPreview,
    toggleBoundaries,
    toggleLayerIndicators,
    toggleADAPanel,
    runADAChecks,
    previewZoom,
    setPreviewZoom,
    showADAPanel,
    resolveAllElements,
  } = usePreviewStore();

  useEffect(() => {
    resolveAllElements();
    runADAChecks();
  }, []);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (
        e.target instanceof HTMLInputElement ||
        e.target instanceof HTMLTextAreaElement ||
        e.target instanceof HTMLSelectElement
      ) {
        return;
      }

      switch (e.key) {
        case '1':
          setPreviewMode('background');
          break;
        case '2':
          setPreviewMode('overlay');
          break;
        case '3':
          setPreviewMode('combined');
          break;
        case 'Escape':
          exitPreview();
          break;
        case 'b':
        case 'B':
          if (!e.ctrlKey && !e.metaKey) toggleBoundaries();
          break;
        case 'l':
        case 'L':
          if (!e.ctrlKey && !e.metaKey) toggleLayerIndicators();
          break;
        case 'a':
        case 'A':
          if (!e.ctrlKey && !e.metaKey) toggleADAPanel();
          break;
        case '=':
        case '+':
          setPreviewZoom(Math.min(previewZoom + 0.1, 3));
          break;
        case '-':
          setPreviewZoom(Math.max(previewZoom - 0.1, 0.25));
          break;
        case '0':
          setPreviewZoom(1);
          break;
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [
    setPreviewMode,
    exitPreview,
    toggleBoundaries,
    toggleLayerIndicators,
    toggleADAPanel,
    previewZoom,
    setPreviewZoom,
  ]);

  return (
    <div className="flex flex-col h-full bg-[#0a0a0f]">
      <PreviewToolbar />

      <div className="flex flex-1 min-h-0">
        <PreviewCanvas />
        <PreviewInfoPanel />
      </div>

      {showADAPanel && (
        <div className="border-t border-white/[0.06] max-h-[30vh] overflow-y-auto bg-[#12121a]">
          <ADACompliancePanel />
        </div>
      )}
    </div>
  );
}
